module.exports = {
      id: "books-vikatan-usage",
      viewBox: "0 0 22 29.5",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#books-vikatan",
      toString: function () {
        return this.url;
      }
    }